import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { About } from './components/About';
import { Portfolio } from './components/Portfolio';
import { Testimonials } from './components/Testimonials';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
import { TechBackground } from './components/TechBackground';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  return <div className="min-h-screen bg-[#0B1426] font-sans text-gray-100 selection:bg-[#d8a43e] selection:text-black overflow-x-hidden relative" data-id="element-0">
      <TechBackground data-id="element-1" />
      <Navbar data-id="element-2" />
      <main className="relative z-10" data-id="element-3">
        <Hero data-id="element-4" />
        <Services data-id="element-5" />
        <About data-id="element-6" />
        <Portfolio data-id="element-7" />
        <Testimonials data-id="element-8" />
        <CTA data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
      <WhatsAppButton data-id="element-11" />
    </div>;
}